import { DEFAULT_ACCESS_TAB_IDS } from "../apps/cacRoles/constants";

export const getStoredAccess = () => {
  const raw = sessionStorage.getItem("access");
  if (raw === null) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

export const setStoredAccess = (access) => {
  if (access === undefined || access === null) {
    sessionStorage.removeItem("access");
    return;
  }
  sessionStorage.setItem("access", JSON.stringify(access));
};

export const clearStoredAccess = () => {
  sessionStorage.removeItem("access");
};

const mergeDefaultAccess = (access) => {
  if (access === null) return null;
  return [...new Set([...DEFAULT_ACCESS_TAB_IDS, ...(access || [])])];
};

/** null access = legacy full access (no access configured) */
export const canAccessScreen = (component) => {
  const access = getStoredAccess();
  if (access === null) return true;
  return mergeDefaultAccess(access).includes(component);
};

export const withMenuAccess = (menus = []) => {
  return menus
    .map((menu) => {
      const sub_menus = (menu.sub_menus || [])
        .map((sub) => ({
          ...sub,
          isAccessible: canAccessScreen(sub.component),
        }))
        .filter((sub) => sub.isAccessible);
      return {
        ...menu,
        sub_menus,
        isAccessible: sub_menus.length > 0,
      };
    })
    .filter((menu) => menu.isAccessible);
};

export const withDefaultAccess = (access) => mergeDefaultAccess(access);
